module.exports = __webpack_public_path__ + "static/media/sample3.a535a944.png";